const initialState = {
  otherJobs: [],
  loading: true,
  error: null,
};

const OtherJobsReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_OTHER_JOBS_REQUEST":
      return {
        ...state,
        otherJobs: [],
        loading: true,
        error: null,
      };

    case "GET_OTHER_JOBS_SUCCESS":
      return {
        ...state,
        otherJobs: payload,
        loading: false,
        error: null,
      };

    case "GET_OTHER_JOBS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
     
    case "POST_OTHER_JOBS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case "POST_OTHER_JOBS_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
      };
    case "POST_OTHER_JOBS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    case "CLEAR_OTHER_JOBS_DATA":
      return {
        ...state,
        loading: false,
        error: null,
        success: false,
        otherJobs: []
      };
        
    default:
      return state;
  }
};

export default OtherJobsReducer;
